export default __webpack_public_path__ + "static/media/flag-colombia.4b5b975c.svg";